<template>
  <div class="pc-v-list">
    <ul v-if="parentList.length !== 0" class="clearfloat">
      <li class="v-li" v-for="item in parentList" :key="item.id" @click="gotoDetail(item.id)">
        <div class="v-li-left">
          <el-image :src="item.imgUrl" fit="cover"></el-image>
          <div class="v-num">{{item.videoCount}}视频</div>
        </div>
        <div class="v-li-right">
          <!-- <h4>{{item.title}}</h4> -->
          <a :href="'/#/videodetail2' + '?id=' + item.id +'&status=1' " >{{item.title}}</a>

          <p style="margin-top:20px;">
            <span class="txt-color1">数据源：</span>
            {{item.groupType == 1?'成片库':'素材库'}}
          </p>
          <p>
            <span class="txt-color1">上传人：</span>
            {{item.createUser}}
          </p>
          <p>
            <span class="txt-color1">时间：</span>
            {{item.createTime}}
          </p>
          <!-- <p>相关人物：{{item.personName}}</p> -->
        </div>
      </li>
    </ul>
    <div v-else class="txt-color1 tac">暂无相关视频~请确认搜索条件</div>
  </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      videoList: [
        {
          id: 0,
          imgUrl: require('../../../assets/img/06.png')
        },
        {
          id: 1,
          imgUrl: require('../../../assets/img/06.png')
        },
        {
          id: 2,
          imgUrl: require('../../../assets/img/06.png')
        },
        {
          id: 3,
          imgUrl: require('../../../assets/img/06.png')
        },
        {
          id: 4,
          imgUrl: require('../../../assets/img/06.png')
        },
        {
          id: 5,
          imgUrl: require('../../../assets/img/06.png')
        }
      ]
    }
  },
  props: {
    parentList: Array
  },
  methods: {
    // 跳转到详情页
    gotoDetail: async function (id) {
      var res = await this.$http.post(`/v1/videoInfo/videoStatus?id=${id}`)
      var { code, message, data } = res.data
      if (code == 0) {
        this.$router.push({
          path: '/videodetail2',
          query: {
            id: id,
            status: '1'
          }
        })
      } else {
        this.$message.error(message)
      }
    }
  },
  mounted: function () {
    // console.log('llllllll')
    // console.log('ccccc',this.parentList);
  },
  watch: {
    parentList: {
      handler: function (newValue, oldValue) {
        console.log('nnnnnn', newValue)
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.pc-v-list {
  background-color: #fff;
  // margin-top: 30px;
  padding: 30px 20px;
  li {
    float: left;
    display: flex;
    width: 48%;
    flex-direction: row;
    margin-right: 4%;
    margin-bottom: 20px;
    // flex-shrink: 1;
    cursor: pointer;
    &:nth-child(2n) {
      margin-right: 0px;
    }
    .v-li-left {
      flex-shrink: 0;
      width: 256px;
      height: 170px;
      margin-right: 10px;
      box-shadow: -10px 10px 2px #d7d7d7;
      position: relative;
      .el-image {
        width: 100%;
        height: 100%;
        border-radius: 5px;
        box-shadow: -5px 5px 1px #969696;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .v-num {
        position: absolute;
        top: 10px;
        right: 15px;
        color: #fff;
        // width: 40px;
        // height: 15px;
        border-radius: 10px;
        border: 1px solid #596067;
        font-size: 12px;
        padding: 0px 8px;
        // background-color: #888173;
        background: rgba(#000, 0.4);
      }
    }
    .v-li-right {
      padding: 10px 10px;
      flex-shrink: 1;
      h4,a {
        font-weight: bold;
        color: #2c3e50!important;
        // overflow: hidden;
        // text-overflow: ellipsis;
        // white-space: nowrap;
        text-align: left;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      p {
        font-size: 14px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/videolist/videocollection.vue